import { Component, Input, OnInit } from '@angular/core';
import { PageProgress } from '../../../../../openapi-ts';
import { translatePageProgressName } from '../../../../utils/translate';

@Component({
  selector: 'app-offer-progress',
  templateUrl: './offer-progress.component.html',
  styleUrl: './offer-progress.component.scss',
})
export class OfferProgressComponent implements OnInit {
  @Input() progression: Array<PageProgress>;

  constructor() {}

  ngOnInit() {}

  // Make the translate function accessible in the template
  translatePageProgressName = translatePageProgressName;

  // Get the index of the first unfinished item
  get firstUnfinishedIndex(): number {
    if (!this.progression) return -1;
    return this.progression.findIndex((item) => !item.finished);
  }

  trackByPageName(index: number, item: PageProgress): string {
    return item.pageName ?? `${index}`;
  }
}
